import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=277dddeb&lang=html&"
import script from "./GameView.vue?vue&type=script&lang=js&"
export * from "./GameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports